import { useCallback } from "react";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch } from "react-redux";
import { rolPatchClearData, rolPostClearData, } from "../../../store/rol/actions";
export var useRolSuccessHandlers = function (_a) {
    var isEdit = _a.isEdit, setSeeToast = _a.setSeeToast, setOpenModalCreate = _a.setOpenModalCreate, resetTriggers = _a.resetTriggers, callRoles = _a.callRoles;
    var dispatch = useDispatch();
    var handleRolSubmitSuccess = useCallback(function () {
        setSeeToast({
            show: true,
            message: isEdit ? "Rol actualizado con éxito" : "Rol creado con éxito",
            type: typeAlert.success,
        });
        setOpenModalCreate(false);
        resetTriggers();
        callRoles(true);
        if (isEdit) {
            dispatch(rolPatchClearData());
        }
        else {
            dispatch(rolPostClearData());
        }
    }, [
        isEdit,
        setSeeToast,
        setOpenModalCreate,
        resetTriggers,
        callRoles,
        dispatch,
    ]);
    return {
        handleRolSubmitSuccess: handleRolSubmitSuccess,
    };
};
